import { getContrastTextColor } from "./getContrastTextColor";
import { hslToHex } from "./hslToHex";
import {
  getIconColorForBackground,
  parseHexColor,
  rgbToHsl
} from "./iconColor";

const clamp01 = (value: number): number => Math.min(1, Math.max(0, value));

/**
 * Avatar initials color: the hue-matched ink from `getIconColorForBackground`,
 * then nudged by whether plain black/white contrast would have picked white
 * (dark background → brighten the ink) or black (light background → darken it),
 * so the initials read a touch stronger than the flat ink.
 *
 * Shared by the HTML `UserAvatar` and the SVG/Konva map avatar renderers so the
 * initials fallback looks identical everywhere.
 */
export const getAvatarTextColor = (bgColor: string): string => {
  const ink = getIconColorForBackground(bgColor);
  const rgb = parseHexColor(ink);
  if (!rgb) return ink;
  const { h, s, l } = rgbToHsl(rgb);
  const wantsWhite = getContrastTextColor(bgColor) === "#FFFFFF";
  const delta = wantsWhite ? 0.06 : -0.1;
  return hslToHex(h, s, clamp01(l + delta));
};
